<template>
  <v-dialog
    v-model="showDialog"
    persistent
    :width="width"
    :class="{'dialog-z-index': zIndex}"
  >
    <v-card color="primary" dark>
      <v-card-text>
        {{ message }}
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  VProgressLinear,
  VDialog,
  VCard,
  VCardText
} from 'vuetify/lib';
export default {
  computed: {
    ...mapGetters(['showDialog', 'message', 'width', 'zIndex'])
  },
  components: {
    VProgressLinear,
    VDialog,
    VCard,
    VCardText
  }
};
</script>
<style scoped>
.dialog-z-index{
  z-index: 3;
}
</style>
